import React, { useContext, useState } from "react";
import { ProductContext } from "../../../stores/session";
import request from "../../../helpers/request";
import endpoints from "../../../helpers/endpoints";

export default function useStatus(data, setData) {
    const { apiPrefix, uuidColumn } = useContext(ProductContext)

    const updateStatus = (event) => {
        if (!data[uuidColumn]) return;
        const newStatus = event.target.value;
        request(true).post(endpoints[`${apiPrefix}_UPDATE_STATUS`], {
            customer: data[uuidColumn],
            status: newStatus
        }).then(r => {
            setData({
                ...data,
                status: newStatus
            })
        }).catch(e => {
            console.log(e);
        })
    }

    return { updateStatus }
}